module.exports = __webpack_public_path__ + "static/img/preview.f97f199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/energizer-overdrive-website-development/preview.png
// module id = 90
// module chunks = 2